import gql from 'graphql-tag'
import client from '@stores/apollo'
import { SpaceTypeFragment, PageInfoFragment } from '@api/fragments'
import { ISpaceTypeWithCompany, IPageInfo } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        spaceTypesConnection: {
          counters: { total: number }
          pageInfo: IPageInfo
          edges: { node: ISpaceTypeWithCompany }[]
        }
      }
    }
  }
}

export default function list({
  after,
  first,
  where,
  orderBy,
}: {
  after?: string | null
  first: number
  where?: any
  orderBy: string
}): Promise<{
  counters: { total: number }
  spaceTypes: ISpaceTypeWithCompany[]
  pageInfo: IPageInfo
}> {
  return client.gql
    .query({
      query: spaceTypesQuery,
      variables: { first, where, orderBy, after },
    })
    .then(
      ({
        data: {
          viewer: {
            company: {
              spaceTypesConnection: { counters, edges, pageInfo },
            },
          },
        },
      }: Payload) => ({
        counters,
        spaceTypes: edges.map(({ node }: { node: ISpaceTypeWithCompany }) => node),
        pageInfo,
      })
    )
}

export const spaceTypesQuery = gql`
  query spaceTypes(
    $first: Int
    $where: SpaceTypeWhereInput
    $orderBy: SpaceTypeOrderByEnum
    $after: String
  ) {
    viewer {
      company {
        spaceTypesConnection(first: $first, where: $where, orderBy: $orderBy, after: $after) {
          counters {
            total
          }
          edges {
            node {
              ...SpaceTypeFragment
              company {
                id
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
        }
      }
    }
  }
  ${SpaceTypeFragment}
  ${PageInfoFragment}
`
